<template>
  <div class="agree">
    <p style="text-align:center;">
      <span class="font-size-large"><b>用户使用协议</b></span>
    </p>
    <p>
      <span class="font-size-normal">欢迎您使用默往服务！</span>
    </p>
    <p>
      <span class="font-size-normal">在使用服务之前，您应当阅读并遵守《默往用户使用协议》（以下简称“本协议”）和《隐私政策条款》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款，以及开通或使用某项服务的单独协议。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。</span>
    </p>
    <p>
      <span class="font-size-normal">当您按照注册页面填写信息、阅读并同意本协议且完成全部注册程序后，或您以其他厦门默往科技有限公司允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的约定，届时您不应以未阅读本协议的内容或者未获得厦门默往科技有限公司对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</span>
    </p>
    <p>
      <span class="font-size-normal">如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。另外，如果您是未满14周岁的儿童，在注册、使用本服务前，请您的监护人充分阅读并理解厦门默往科技有限公司制定的</span><span class="font-size-normal">未成年隐私保护相关条款</span><span class="font-size-normal">。若您未取得监护人对</span><span class="font-size-normal">未成年隐私保护相关条款</span><span class="font-size-normal">的同意，则您不得使用本服务。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>一、缔约主体</b></span>
    </p>
    <p>
      <span class="font-size-normal">本协议由通过默往移动客户端软件及其他方式使用默往服务的用户与厦门默往科技有限公司共同缔结。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>二、协议内容和效力</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、本协议内容包括本协议正文及所有已经发布或将来可能发布的隐私政策、各项政策、规则、声明、通知、警示、提示、说明（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。</span>
    </p>
    <p>
      <span class="font-size-normal">2、厦门默往科技有限公司有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则一经公布，立即取代原协议及规则并自动生效。如您不同意相关变更，应当立即停止使用默往服务，如您继续使用默往服务或进行任何与默往有关的活动，即表示您已接受经修订的协议和规则。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>三、服务内容</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、厦门默往科技有限公司提供各种形式服务软件（以下简称“本服务”），包括但不限于手机客户端ios版本、Android版本等（具体以厦门默往科技有限公司提供的为准）。厦门默往科技有限公司会不断丰富您使用本服务的终端、形式等，本协议自动适用于您对所有版本的软件和服务的使用。</span>
    </p>
    <p>
      <span class="font-size-normal">2、厦门默往科技有限公司许可您对默往软件进行非排他性的使用，您可以制作本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息，本协议及规则中未明示授权的其他权利仍由厦门默往科技有限公司保留，您在行使这些权利时须另外取得厦门默往科技有限公司的书面许可。厦门默往科技有限公司如果未行使前述任何权利，并不构成对该权利的放弃。</span>
    </p>
    <p>
      <span class="font-size-normal">3、本服务内容包含但不限于支持通讯录、会话、消息未读列表等技术功能，这些功能服务可能根据用户需求的变化，随着因服务版本不同、或服务提供方的单方判断而被优化或修改，或因定期、不定期的维护而暂缓提供。</span>
    </p>
    <p>
      <span class="font-size-normal">4、同时，厦门默往科技有限公司保留在任何时候自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的权利。您同意，对于上述行为，厦门默往科技有限公司均不需通知，并且对您和任何第三人不承担任何责任。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>四、软件的安装、升级及卸载</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、您应根据实际情况下载合适的版本并按照提示的步骤正确安装本软件。</span>
    </p>
    <p>
      <span class="font-size-normal">2、为了完善服务内容、提高用户体验，同时为了保证本软件及服务的安全性和功能的一致性，厦门默往科技有限公司有权自行对软件进行更新，或者对软件的部分功能效果进行改变或限制，您已理解并同意厦门默往科技有限公司上述行为。</span>
    </p>
    <p>
      <span class="font-size-normal">3、如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>五、注册及账号管理</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、您确认，在您注册、使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备上述资格，请勿使用本服务，否则您应承担因此造成的一切后果，若您有监护人的，您的监护人应与您承担因此造成的一切后果，且厦门默往科技有限公司有权注销（永久冻结）您的账户并索偿。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您注册时应提交真实、准确、完整和反映当前情况的身份及其他相关信息。您理解并同意，您承诺注册的账号名称、头像等信息中不得出现违法违规和不良信息，不得冒充第三方，不得未经许可为第三方注册，不得以可能导致其他用户误认的方式注册或设置默往账号，不得使用可能侵犯第三方权益的用户名（包括但不限于涉嫌商标权、名誉权侵权等），否则厦门默往科技有限公司有权不予注册或停止服务并收回默往账号，因此产生的损失由您自行承担。</span>
    </p>
    <p>
      <span class="font-size-normal">3、您可以使用您提供或确认的手机号或者厦门默往科技有限公司允许的其它方式作为账号进行注册，并承诺注册的账号名称、头像和简介等信息中不得出现违法违规和不良信息，不得冒充第三方进行注册，不得未经许可为第三方注册，不得以可能导致其他用户误认的方式注册账号，不得使用可能侵犯第三方权益的用户名进行注册（包括但不限于涉嫌商标权、名誉权侵权等），否则厦门默往科技有限公司有权不予注册或停止服务并收回账号，因此产生的损失由您自行承担。</span>
    </p>
    <p>
      <span class="font-size-normal">4、您了解并同意，默往注册账号所有权归属于厦门默往科技有限公司，注册完成后，您仅获得账号使用权。默往账号使用权仅归属于初始申请注册人，不得以任何方式转让或被提供予第三方使用，否则，厦门默往科技有限公司有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。</span>
    </p>
    <p>
      <span class="font-size-normal">5、在您成功注册后，厦门默往科技有限公司将根据账号和密码确认您的身份。您应妥善保管您的终端及账户和密码，并对利用该账户和密码所进行的一切活动（包括但不限于网上点击同意或提交各类规则协议或购买服务、分享资讯或图片、发起语音通话等）负全部责任。您承诺，在密码或账户遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知厦门默往科技有限公司，且您同意并确认，厦门默往科技有限公司不对上述情形产生的任何直接或间接的遗失或损害承担责任。除非有法律规定或司法裁定，且征得厦门默往科技有限公司的同意，否则，您的账户、密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>六、服务使用规范</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、用户充分了解并同意，厦门默往科技有限公司仅为用户提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任。相应地，使用默往服务可能发生来自他人非法或不当行为（或信息）的风险，您了解并同意，厦门默往科技有限公司已尽合理努力保障您能安全使用本服务，您应自行判断及行动，并自行承担相应的风险，若您发现有来自他人非法或不当行为（或信息）的风险，您应立即通知厦门默往科技有限公司。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。</span>
    </p>
    <p>
      <span class="font-size-normal">3、除非另有说明，本协议项下的服务只能用于非商业用途。您承诺不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于包括但不限于广告及任何其它商业目的。</span>
    </p>
    <p>
      <span class="font-size-normal">4、您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为:</span>
    </p>
    <p>
      <span class="font-size-normal">4.1&nbsp;上载、传送或分享含有下列内容之一的信息：</span>
    </p>
    <p>
      <span class="font-size-normal">(a)&nbsp;反对宪法所确定的基本原则的；</span>
    </p>
    <p>
      <span class="font-size-normal">(b)&nbsp;危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
    </p>
    <p>
      <span class="font-size-normal">(c)&nbsp;损害国家荣誉和利益的；</span>
    </p>
    <p>
      <span class="font-size-normal">(d)&nbsp;煽动民族仇恨、民族歧视、破坏民族团结的；</span>
    </p>
    <p>
      <span class="font-size-normal">(e)&nbsp;破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
    </p>
    <p>
      <span class="font-size-normal">(f)&nbsp;散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
    </p>
    <p>
      <span class="font-size-normal">(g)&nbsp;散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
    </p>
    <p>
      <span class="font-size-normal">(h)&nbsp;侮辱或者诽谤他人，侵害他人合法权利的；</span>
    </p>
    <p>
      <span class="font-size-normal">(i)&nbsp;含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</span>
    </p>
    <p>
      <span class="font-size-normal">(j)&nbsp;含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</span>
    </p>
    <p>
      <span class="font-size-normal">4.2&nbsp;冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</span>
    </p>
    <p>
      <span class="font-size-normal">4.3&nbsp;伪造标题或以其他方式操控识别资料，使人误认为该内容为厦门默往科技有限公司或其关联公司所传送；</span>
    </p>
    <p>
      <span class="font-size-normal">4.4&nbsp;将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以上载、传送或分享；</span>
    </p>
    <p>
      <span class="font-size-normal">4.5&nbsp;将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权）之内容上载、传送或分享；</span>
    </p>
    <p>
      <span class="font-size-normal">4.6&nbsp;跟踪或以其它方式骚扰他人,&nbsp;或通过本服务向好友或其他用户发送大量信息；</span>
    </p>
    <p>
      <span class="font-size-normal">4.7&nbsp;将任何广告、推广信息、促销资料、“垃圾邮件”、“滥发信件”、“连锁信件”、“直销”或其它任何形式的劝诱资料加以上载、传送或分享；供前述目的使用的专用区域或专用功能除外；</span>
    </p>
    <p>
      <span class="font-size-normal">4.8&nbsp;因本服务并非为某些特定目的而设计，您不可将本服务用于包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，厦门默往科技有限公司不承担法律责任；</span>
    </p>
    <p>
      <span class="font-size-normal">4.9&nbsp;进行任何超出正常的好友或用户之间内部或外部信息沟通、交流等目的的行为；</span>
    </p>
    <p>
      <span class="font-size-normal">4.10&nbsp;出于超出正常好友或用户之间内部或外部信息沟通、交流等目的（包括但不限于为发送广告、垃圾、骚扰或违法违规等信息的目的），通过自己添加或诱导他人添加等任何方式使自己与其他用户形成好友关系（好友关系包括但不限于单向好友关系和双向好友关系，下同）；通过本服务向好友或其他用户发送大量信息；</span>
    </p>
    <p>
      <span class="font-size-normal">4.11&nbsp;违反遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的行为；</span>
    </p>
    <p>
      <span class="font-size-normal">4.12&nbsp;从事任何违反中国法律、法规、规章、政策及规范性文件的行为。</span>
    </p>
    <p>
      <span class="font-size-normal">5、您承诺不对本软件和服务从事以下行为：</span>
    </p>
    <p>
      <span class="font-size-normal">5.1&nbsp;将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；</span>
    </p>
    <p>
      <span class="font-size-normal">5.2&nbsp;干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；</span>
    </p>
    <p>
      <span class="font-size-normal">5.3&nbsp;通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span>
    </p>
    <p>
      <span class="font-size-normal">5.4&nbsp;通过非厦门默往科技有限公司开发、授权的第三方软件、插件、外挂、系统，登录或使用软件及服务，或制作、发布、传播上述工具；</span>
    </p>
    <p>
      <span class="font-size-normal">5.5&nbsp;自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰。</span>
    </p>
    <p>
      <span class="font-size-normal">6、您承诺，使用默往服务时您将严格遵守本协议及规则。</span>
    </p>
    <p>
      <span class="font-size-normal">7、您同意并接受厦门默往科技有限公司无须时时监控您上载、传送或分享的资料及信息，但厦门默往科技有限公司有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。</span>
    </p>
    <p>
      <span class="font-size-normal">8、您承诺不以任何形式使用本服务侵犯厦门默往科技有限公司的商业利益，或从事任何可能对厦门默往科技有限公司造成损害或不利于厦门默往科技有限公司的行为。</span>
    </p>
    <p>
      <span class="font-size-normal">9、您了解并同意，在厦门默往科技有限公司服务提供过程中，厦门默往科技有限公司及其关联公司或其授权单位和个人有权以各种方式投放各种商业性广告或其他任何类型的推广信息，同时，您同意接受以电子邮件或其他方式向您发送的上述广告或推广信息。</span>
    </p>
    <p>
      <span class="font-size-normal">10、您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。厦门默往科技有限公司无法且不会对您因前述风险而导致的任何损失或损害承担责任。</span>
    </p>
    <p>
      <span class="font-size-normal">11、如果厦门默往科技有限公司发现或收到他人举报您有违反本协议约定的，厦门默往科技有限公司有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于收回账号，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>七、服务费用</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、本服务的任何免费试用或免费功能和服务不应视为厦门默往科技有限公司放弃后续收费的权利。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您应当自行支付使用本服务可能产生的上网费以及其他第三方收取的通讯费、信息费等。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>八、特别授权</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、当您向厦门默往科技有限公司关联公司作出任何形式的承诺，且相关公司已确认您违反了该承诺，则厦门默往科技有限公司有权立即按您的承诺约定的方式对您的账户采取限制措施，包括但不限于中止或终止向您提供服务，并公示相关公司确认的您的违约情况。您了解并同意，厦门默往科技有限公司无须就相关确认与您核对事实，或另行征得您的同意，且厦门默往科技有限公司无须就此限制措施或公示行为向您承担任何的责任。</span>
    </p>
    <p>
      <span class="font-size-normal">2、一旦您违反本协议，或与厦门默往科技有限公司签订的其他协议的约定，厦门默往科技有限公司有权以任何方式通知厦门默往科技有限公司关联公司，要求其对您的权益采取限制措施，包括但不限于要求厦门默往科技有限公司关联公司中止、终止对您提供部分或全部服务，且在其经营或实际控制的任何网站公示您的违约情况。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>九、第三方应用</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、厦门默往科技有限公司允许第三方应用接入服务平台，您可以在厦门默往科技有限公司直接获得包括但不限于OA软件等第三方应用服务。您了解并同意，厦门默往科技有限公司仅作为平台提供者，相关应用由该第三方独立提供，厦门默往科技有限公司不对您对该应用的使用承担任何责任。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您了解并同意，如厦门默往科技有限公司对服务或其部分做出调整、中止或终止而对第三方应用服务产生影响，厦门默往科技有限公司不承担任何责任。</span>
    </p>
    <p>
      <span class="font-size-normal">3、您通过第三方应用或服务使用默往时，厦门默往科技有限公司可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十、服务中止或终止</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、您同意，鉴于互联网服务的特殊性，厦门默往科技有限公司有权随时中止、终止或致使中止终止服务或其任何部分；对于免费服务之中止或终止，厦门默往科技有限公司无需向您发出通知。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您理解并同意，厦门默往科技有限公司有权自主决定经营策略。在厦门默往科技有限公司发生合并、分立、收购、资产转让时，厦门默往科技有限公司可向第三方转让本服务下相关资产；厦门默往科技有限公司也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以厦门默往科技有限公司通知的为准。</span>
    </p>
    <p>
      <span class="font-size-normal">3、如存在下列违约情形之一，厦门默往科技有限公司可立即对用户中止或终止服务，并要求用户赔偿损失：</span>
    </p>
    <p>
      <span class="font-size-normal">3.1&nbsp;用户违反第四条之注册义务；</span>
    </p>
    <p>
      <span class="font-size-normal">3.2&nbsp;用户违反相关法律法规或本协议的约定；</span>
    </p>
    <p>
      <span class="font-size-normal">3.3&nbsp;按照法律规定或主管部门的要求；</span>
    </p>
    <p>
      <span class="font-size-normal">3.4&nbsp;出于安全的原因或其他必要的情形。</span>
    </p>
    <p>
      <span class="font-size-normal">4、您了解并同意，如您利用本服务并存在上述第三款的情况时，厦门默往科技有限公司有权不经通知限制、暂停、终止您使用默往账号及服务，当您账号已被限制、暂停、终止的，您应于账户被封禁之日起60日内通过余额提取通道提取账号内余额。若您未在60日内通过余额提取通道提取账号余额的，视为您自行放弃提取账号内余额的权利，厦门默往科技有限公司将于60日届满之日对您的默往账号进行永久封号并永久关闭您的余额提取通道。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十一、隐私政策</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、您在默往服务注册的账户具有密码保护功能，以确保您基本信息资料的安全，请您妥善保管账户及密码信息。</span>
    </p>
    <p>
      <span class="font-size-normal">2、厦门默往科技有限公司努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在默往中的信息和通信内容不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。厦门默往科技有限公司对可能接触到信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。厦门默往科技有限公司会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，厦门默往科技有限公司将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失，&nbsp;但同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。</span>
    </p>
    <p>
      <span class="font-size-normal">3、厦门默往科技有限公司有权根据实际情况自行决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大存储空间等，您应当保管好终端、账号及密码，并妥善保管相关信息和内容，厦门默往科技有限公司对您自身原因导致的数据丢失或被盗以及在本软件及服务中相关数据的删除或储存失败不承担责任。</span>
    </p>
    <p>
      <span class="font-size-normal">4、其他隐私条款见《默往服务隐私政策》。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十二、知识产权</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、您了解及同意，除非厦门默往科技有限公司另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、色彩、版面设计）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归厦门默往科技有限公司或其关联公司所有。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您应保证，除非取得厦门默往科技有限公司书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始码等的行为。</span>
    </p>
    <p>
      <span class="font-size-normal">3、默往服务涉及的Logo、“默往”、等文字、图形及其组成，以及厦门默往科技有限公司其他标识、产品和服务名称均为厦门默往科技有限公司及其关联公司在中国和其它国家的商标，用户未经厦门默往科技有限公司书面授权不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用、或作其他处理。</span>
    </p>
    <p>
      <span class="font-size-normal">4、您理解并同意授权厦门默往科技有限公司在宣传和推广中使用您的名称、商标、标识，但仅限于表明您属于厦门默往科技有限公司的客户或合作伙伴。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十三、有限责任</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、服务将按"现状"和按"可得到"的状态提供。厦门默往科技有限公司在此明确声明对服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性，没有错误或疏漏，持续性，准确性，可靠性，适用于某一特定用途之类的保证，声明或承诺。</span>
    </p>
    <p>
      <span class="font-size-normal">2、厦门默往科技有限公司对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作承诺和保证。</span>
    </p>
    <p>
      <span class="font-size-normal">3、不论在何种情况下，厦门默往科技有限公司均不对由于Internet连接故障，电脑，通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</span>
    </p>
    <p>
      <span class="font-size-normal">4、不论是否可以预见，不论是源于何种形式的行为，厦门默往科技有限公司不对由以下原因造成的任何特别的，直接的，间接的，惩罚性的，突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失，营业中止，资料灭失）承担责任。</span>
    </p>
    <p>
      <span class="font-size-normal">4.1&nbsp;使用或不能使用服务；</span>
    </p>
    <p>
      <span class="font-size-normal">4.2&nbsp;通过服务购买或获取任何产品，样品，数据，信息或进行交易等，或其他可替代上述行为的行为而产生的费用；</span>
    </p>
    <p>
      <span class="font-size-normal">4.3&nbsp;未经授权的存取或修改数据或数据的传输；</span>
    </p>
    <p>
      <span class="font-size-normal">4.4&nbsp;第三方通过服务所作的陈述或行为；</span>
    </p>
    <p>
      <span class="font-size-normal">4.5&nbsp;其它与服务相关事件，包括疏忽等，所造成的损害。</span>
    </p>
    <p>
      <span class="font-size-normal">5、您充分了解并同意，鉴于互联网体制及环境的特殊性，您在服务中分享的信息及个人资料有可能会被他人复制、转载、擅改或做其它非法用途；您在此已充分意识此类风险的存在，并确认此等风险应完全由您自行承担，厦门默往科技有限公司对此不承担任何责任。</span>
    </p>
    <p>
      <span class="font-size-normal">6、您了解并同意，在使用服务过程中可能存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）及匿名或冒名的信息的风险，基于服务使用规范所述，该等风险应由您自行承担，厦门默往科技有限公司对此不承担任何责任。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十四、违约责任及赔偿</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、如果厦门默往科技有限公司发现或收到他人举报您有违反本协议约定的，厦门默往科技有限公司有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于限制、暂停、终止您使用默往账号及服务，限制、暂停、终止您使用部分或全部本服务（包括但不限于删除通信录、限制增加成员、限制发送消息或添加好友等），追究法律责任等措施。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您同意，由于您通过服务上载、传送或分享之信息、使用本服务其他功能、违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人向厦门默往科技有限公司及其关联公司提出任何索赔或请求，或厦门默往科技有限公司及其关联公司因此而发生任何损失，您同意将足额进行赔偿（包括但不限于合理律师费）。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十五、有效通知</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、厦门默往科技有限公司向您发出的任何通知，可采用电子邮件、页面公开区域公告、个人网络区域提示、手机短信或常规信件等方式，且该等通知应自发送之日视为已向用户送达或生效。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。默往发出的各类通知、公告均为本协议的组成部分，若您无法同意通知、公告确定的内容，请您停止使用本软件。</span>
    </p>
    <p>
      <span class="font-size-normal">2、您同意，您向厦门默往科技有限公司发出的任何通知应发至默往对外正式公布或以第十七条所述方式告知用户的电子邮件、通信地址、传真号码等联系信息，或使用其他厦门默往科技有限公司认可的其他通知方式进行送达。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十六、争议解决及其他</b></span>
    </p>
    <p>
      <span class="font-size-normal">1、本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理。</span>
    </p>
    <p>
      <span class="font-size-normal">2、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。</span>
    </p>
    <p>
      <span class="font-size-normal">3、默往于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。</span>
    </p>
    <p>
      <span class="font-size-normal">4、本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。</span>
    </p>
    <p>
      <span class="font-size-normal">5、厦门默往科技有限公司有权根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司，转让将以本协议规定的方式通知，用户承诺对此不持有异议。</span>
    </p>
    <p style="margin:0;padding:2px 8px;background-color:#ffffff">
      <span class="font-size-normal">6、本协议签订地为中华人民共和国福建省厦门市。</span>
    </p>
    <p style="margin:0;padding:2px 8px;background-color:#ffffff">
      <span class="font-size-normal">7、若您和厦门默往科技有限公司之间发生任何纠纷或争议，应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</span>
    </p>
    <p>
      <span class="font-size-normal"><b>十七、联系方式</b></span>
    </p>
    <p>
      <span class="font-size-normal">如果您对本协议/本服务有意见/建议，或您在使用本服务过程中有其他问题的，可与默往客服联系（客服热线4006008017），厦门默往科技有限公司会给予您必要的帮助。</span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'Agree',
  created () {
    document.title = '用户使用协议'
  }
}
</script>

<style lang="scss" scoped>
.agree {
  line-height: 1.5;
  padding: 10px;
  font-size: 15px;
}
</style>
